(function (angular) {
	angular.module('bizPartEngage').directive('bizLayoutComponent', bizLayoutComponent);
	angular.module('bizPartEngage').service('bizLayoutComponentService', bizLayoutComponentService);

	bizLayoutComponent.$inject = ["bizLayoutComponentService", "$compile", "container", "$rootScope"];
	bizLayoutComponentService.$inject = ["$http"]

	function bizLayoutComponent(bizLayoutComponentService, $compile, container, $rootScope) {
		var directive = {
			restrict: "A",
			link: bizLayoutComponentLink
		}

		function bizLayoutComponentLink(scope, element, attrs) {
			var preventSetFinishedAttr = '';

			if (attrs.preventSetFinished !== undefined) {
				preventSetFinishedAttr = ' prevent-set-finished="' +
					(attrs.preventSetFinished || 'true') + '"';
			}

			var htm = '<biz-container-show container="LayoutComponent.Container"' +
				preventSetFinishedAttr +
				'></biz-container-show>';

			if (!attrs.bizLayoutComponent)
				return;

			var htmV2 = `<div id="bizcontainerv2-layout-component-${attrs.bizLayoutComponent}" params="{container: LayoutComponent.Container}" biz-react-wrapper></div>`
			
			bizLayoutComponentService.GetLayoutComponent(attrs.bizLayoutComponent).then(GetLayoutComponentCallback);

			function GetLayoutComponentCallback(response) {
				scope.LayoutComponent = BizPartCoreHelpers.getResponseValue(response, {});

				if (scope.LayoutComponent.Container) {
					const containerVersion = scope.LayoutComponent.Container.Version || scope.LayoutComponent.Container.version || 1;
					const isContainerV2 = containerVersion >= 2 || !!scope.LayoutComponent.Container.placeholders;
					const useV2 = isContainerV2 || $rootScope.MiniSettings.Container.useContainerV2ForComponents.includes(attrs.bizLayoutComponent);
					if (!useV2) {
						scope.LayoutComponent.Container = new container(scope.LayoutComponent.Container);
					}
					var compiled = $compile(useV2 ? htmV2 : htm)(scope);
					element.html(compiled);
				}
			}
		}

		return directive;
	}

	function bizLayoutComponentService($http) {
		var servicepath = siteRootPath + "api/layout/";

		this.GetLayoutComponent = function (type) {
			return $http.get(servicepath + "GetLayoutComponentForUser", {
				params: {
					type: type
				}
			});
		}
	}
})(window.angular);
